// extracted by mini-css-extract-plugin
export default {"hidden":"UserManagementUsersRoles_hidden__oA3uo","deleteCell":"UserManagementUsersRoles_deleteCell__6F6Qs"};